import "react-multi-carousel/lib/styles.css";

import Carousel from "react-multi-carousel";

import { Button } from "@aidron/aidron-ds";

import { Container } from "./MultiSlideCarousel.style";

import PropTypes from "prop-types";

function SideButton({ side, onClick }) {
  return (
    <Button
      className={`react-multiple-carousel__arrow react-multiple-carousel__arrow--${side} custom-carousel-arrow-button`}
      icon={`chevron-${side}`}
      type="outlined"
      position="left"
      onClick={onClick}
      label=""
    />
  );
}

export function MultiSlideCarousel({ children, slideCount }) {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <Container>
      <Carousel
        responsive={responsive}
        customLeftArrow={<SideButton side="left" />}
        customRightArrow={<SideButton side="right" />}
        showDots
        renderDotsOutside
        className={`${slideCount <= 3 ? "justify-content-center" : ""}`}>
        {children}
      </Carousel>
    </Container>
  );
};

SideButton.propTypes = {
  side: PropTypes.string,
  onClick: PropTypes.func
}

MultiSlideCarousel.propTypes = {
  children: PropTypes.node,
  slideCount: PropTypes.number
}